import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListTable from '../../../components/ListTable';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { IconButton } from '@material-ui/core';
import { DEFAULT } from '../../../constants';

// Redux
import { connect } from 'react-redux';
import { setSuccess, clearErrors, setAlert } from '../../../redux/actions/alertActions';

// Icons
import ViewIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';

// API
import { listBadges, deleteBadge } from '../../../api';

// Constants
const COLUMNS = (setupMode, onDelete) => [
  ...(setupMode ? [
    {
      title: 'View',
      render: rowData => (
        <Link to={'/admin/badges/' + rowData.getSerialNumber()}><ViewIcon /></Link>
      ),
      width: null,
      cellStyle: {
        width: 25
      }
    },
    {
      title: 'Delete',
      render: rowData => (
        <IconButton onClick={() => onDelete(rowData)}><DeleteIcon /></IconButton>
      ),
      width: null,
      cellStyle: {
        width: 25
      }
    }
  ] : []),
  {
    field: 'serialNumber',
    title: 'Serial Number'
  },
  {
    render: rowData => (
      rowData.getBadgeType()?.getName() ?? 'Unknown'
    ),
    title: 'Badge Type'
  },
  {
    title: 'Assigned To',
    render: rowData => (
      rowData.getBelongsTo()?.firstName + ' ' + rowData.getBelongsTo()?.lastName
    ),
    customFilterAndSearch: (term, rowData) => {
      let name = rowData.getBelongsTo()?.firstName + ' ' + rowData.getBelongsTo()?.lastName;
      return name?.toLowerCase()?.includes(term.toLowerCase());
    }
  },
  {
    render: rowData => (
      rowData.getLastSeenTimestamp()?.toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    ),
    title: 'Last Seen'
  },
  {
    title: 'Firmware Version',
    field: 'firmwareVersion'
  }
];

class Badges extends Component {

  constructor(props) {
    super(props);

    this.state = {
      confirmDeleteBadge: null,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  onDelete = (badge) => {
    this.setState({ confirmDeleteBadge: badge });
  }

  deleteBadge = () => {
    this.setState({ isLoading: true });
    deleteBadge(this.state.confirmDeleteBadge.getSerialNumber()).then(() => {
      this.setState({ isLoading: false, confirmDeleteBadge: null });
      this.props.setSuccess('Badge deleted successfully.');
      // Temp: Refresh page
      window.location.reload();
    }).catch(error => {
      this.setState({ isLoading: false });
      this.props.setError(error ?? 'Error: Unable to delete badge.');
    });
  }

  render() {
    return (
      <>
        <ConfirmationModal
          open={this.state.confirmDeleteBadge != null}
          onClose={() => this.setState({ confirmDeleteBadge: null })}
          onConfirm={this.deleteBadge}
          color={this.props.statusColor}
          title={`Are you sure you want to delete badge ${this.state.confirmDeleteBadge?.getSerialNumber()}?`}
          body={'The badge will no longer be able to receive or send alerts.'}
          isLoading={this.state.isLoading}
        />

        <ListTable
          title='Badges'
          buttonLink='/admin/badges/assign'
          buttonText='Assign New'
          columns={COLUMNS(this.props.setupMode, this.onDelete)}
          retrievalFunction={listBadges}
          hideButton={!this.props.setupMode}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  setupMode: state.setupMode.mode || state.setupMode.isLoading,
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => {
    dispatch(clearErrors());
    setAlert(dispatch, msg);
  },
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

Badges.propTypes = {
  setupMode: PropTypes.bool.isRequired,
  statusColor: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Badges);
